var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.105C10 9.95989 10.0286 9.8162 10.0841 9.68213C10.1396 9.54807 10.221 9.42626 10.3236 9.32365C10.4263 9.22104 10.5481 9.13964 10.6821 9.08411C10.8162 9.02858 10.9599 9 11.105 9H12.895C13.0401 9 13.1838 9.02858 13.3179 9.08411C13.4519 9.13964 13.5737 9.22104 13.6764 9.32365C13.779 9.42626 13.8604 9.54807 13.9159 9.68213C13.9714 9.8162 14 9.95989 14 10.105V19.895C14 20.1881 13.8836 20.4691 13.6764 20.6764C13.4691 20.8836 13.1881 21 12.895 21H11.105C10.8119 21 10.5309 20.8836 10.3236 20.6764C10.1164 20.4691 10 20.1881 10 19.895V10.105Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.105C17 3.81194 17.1164 3.53087 17.3236 3.32365C17.5309 3.11642 17.8119 3 18.105 3H19.895C20.1881 3 20.4691 3.11642 20.6764 3.32365C20.8836 3.53087 21 3.81194 21 4.105V19.895C21 20.1881 20.8836 20.4691 20.6764 20.6764C20.4691 20.8836 20.1881 21 19.895 21H18.105C17.8119 21 17.5309 20.8836 17.3236 20.6764C17.1164 20.4691 17 20.1881 17 19.895V4.105Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21C5.53043 21 6.03914 20.7893 6.41421 20.4142C6.78929 20.0391 7 19.5304 7 19C7 18.4696 6.78929 17.9609 6.41421 17.5858C6.03914 17.2107 5.53043 17 5 17C4.46957 17 3.96086 17.2107 3.58579 17.5858C3.21071 17.9609 3 18.4696 3 19Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannersIcon);
export default __webpack_public_path__ + "static/media/BannersIcon.3f032c0902b9059cf62b1e2dcd734a85.svg";
export { ForwardRef as ReactComponent };